import React, { useEffect, useMemo } from 'react'
import AsyncSelect from 'react-select/async'
import { debounce } from 'lodash'
import { fetchCities } from 'services/api/influencer'

type CityOption = { value: string; label: string }

interface CitySelectionProps {
    value: string
    onChange: (selected: string) => void
    invalid?: boolean
    menuPlacement?: 'auto' | 'top' | 'bottom'
}

const CitySelection: React.FC<CitySelectionProps> = ({
    value,
    onChange,
    invalid = false,
    menuPlacement = 'top',
}) => {
    const loadCitiesSuggestions = useMemo(
        () =>
            debounce((query: string, callback: (options: CityOption[]) => void) => {
                if (!query || query.length < 3) {
                    callback([])
                    return
                }
                fetchCities(query)
                    .then((resp) =>
                        callback(resp.map((item: string) => ({ value: item, label: item })))
                    )
                    .catch(() => callback([]))
            }, 200),
        []
    )

    useEffect(() => {
        return () => loadCitiesSuggestions.cancel()
    }, [loadCitiesSuggestions])

    const selectedValue = value ? { label: value, value } : null

    return (
        <AsyncSelect
            isClearable
            cacheOptions
            classNamePrefix="influencer-profile-city"
            className={`influencer-profile-city-select${invalid ? ' is-invalid' : ''}`}
            placeholder="Location"
            noOptionsMessage={() => 'Start typing...'}
            menuPlacement={menuPlacement}
            loadOptions={loadCitiesSuggestions}
            value={selectedValue}
            onChange={(selected) => onChange(selected?.value ?? '')}
        />
    )
}

export default CitySelection
